import React, { useEffect, useState, useRef } from "react";
import "./Mid-Section-Mobile.scss";

//import icons
import { CiEdit } from "react-icons/ci";
import { FaArrowRightLong } from "react-icons/fa6";
import { SlLogout } from "react-icons/sl";
import { RiLockPasswordFill } from "react-icons/ri";
import { CgArrowsExchangeAlt } from "react-icons/cg";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";

const MidSectionProfile = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);

  useEffect(() => {
    dispatch(getProfile({ id, token })).then((res) => {
      console.log("profile update", res);
      setProfileUpdated(true);
    });
  }, [user]);

  //input values
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    if (profileUpdated && profile.user_name) {
      const { firstName, lastName } = getFirstAndLastName(profile.user_name);
      setFirstName(firstName);
      setLastName(lastName);
      setEmail(profile.user_email || "");
      setPhoneNumber(profile.user_phone_number || "");
      setProfilePicture(profile.profile_picture || null);
    }
  }, [profileUpdated]);

  const [selectedOption, setSelectedOption] = useState("");
  const [focus, setFocus] = useState({}); // Track focus state

  useEffect(() => {
    console.log(selectedOption);
  }, [selectedOption]);

  //upload image
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Handle the file (e.g., upload or display it)
      console.log("Selected file:", file);
    }
  };

  //function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        break;
      default:
        break;
    }
  };

  //focus
  const handleFocus = (inputName) => {
    setFocus({ ...focus, [inputName]: true });
  };

  const handleBlur = (inputName) => {
    setFocus({ ...focus, [inputName]: false });
  };

  return (
    <div className="profile-page">
      {selectedOption === "" ? (
        <>
          <div className="top-side">
            {profilePicture ? (
              <>
                <img
                  src={profilePicture}
                  alt="profile picture"
                  className="profile-picture"
                />
              </>
            ) : (
              <div className="image"></div>
            )}

            <div className="name">{profile.user_name}</div>
            <div className="email">{email}</div>
          </div>
          <div className="bottom-side">
            <div className="choices-container">
              <button
                style={{
                  margin: "0px",
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "100%",
                  border: "none",
                }}
                onClick={() => {
                  setSelectedOption("Profile");
                }}
              >
                <div className="choices">
                  <div className="icon">
                    <CiEdit fontSize={25} />
                  </div>
                  <div className="text">Edit Profile</div>
                  <div className="icon">
                    <FaArrowRightLong fontSize={20} />
                  </div>
                </div>
              </button>
              <button
                style={{
                  margin: "0px",
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "100%",
                  border: "none",
                }}
                onClick={() => {
                  setSelectedOption("Plans");
                }}
              >
                {/* <div className="choices">
                  <div className="icon">
                    <CgArrowsExchangeAlt fontSize={25} />
                  </div>
                  <div className="text">Change Plan</div>
                  <div className="icon">
                    <FaArrowRightLong fontSize={20} />
                  </div>
                </div> */}
              </button>
              <button
                style={{
                  margin: "0px",
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "100%",
                  border: "none",
                }}
                onClick={() => {
                  setSelectedOption("Password");
                }}
              >
                <div className="choices">
                  <div className="icon" style={{ marginTop: "1.5%" }}>
                    <RiLockPasswordFill fontSize={21} />
                  </div>

                  <div className="text">Change Password</div>
                  <div className="icon">
                    <FaArrowRightLong fontSize={20} />
                  </div>
                </div>
              </button>
              <button
                style={{
                  margin: "0px",
                  padding: "0px",
                  backgroundColor: "transparent",
                  width: "100%",
                  border: "none",
                }}
                onClick={() => {
                  setSelectedOption("Logout");
                }}
              >
                <div className={`choices no-border`}>
                  <div className="icon" style={{ marginTop: "2.5%" }}>
                    <SlLogout fontSize={20} />
                  </div>
                  <div className="text">Logout</div>
                  <div className="icon" style={{ marginTop: "1.5%" }}>
                    <FaArrowRightLong fontSize={20} />
                  </div>
                </div>
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          {selectedOption === "Profile" && (
            <div className="edit-profile">
              <div className="top-side-profile">
                <div className="porfile-image">
                  <div className="edit-icon">
                    <CiEdit fontSize={20} />
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "block" }}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="bottom-side-profile">
                <div className="fields-halves">
                  <div className="individual-half">
                    <label
                      htmlFor="first-name-input"
                      className={`text ${
                        focus["first-name-input"] ? "focus" : ""
                      }`}
                    >
                      First Name:
                    </label>
                    <input
                      type="text"
                      id="first-name-input"
                      value={firstName}
                      name="firstName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("first-name-input")}
                      onBlur={() => handleBlur("first-name-input")}
                    />
                  </div>
                  <div className="individual-half">
                    <label
                      htmlFor="last-name-input"
                      className={`text ${
                        focus["last-name-input"] ? "focus" : ""
                      }`}
                    >
                      Last Name:
                    </label>
                    <input
                      type="text"
                      id="last-name-input"
                      value={lastName}
                      name="lastName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("last-name-input")}
                      onBlur={() => handleBlur("last-name-input")}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="email-input"
                      className={`text ${focus["email-input"] ? "focus" : ""}`}
                    >
                      email
                    </label>
                    <input
                      type="text"
                      id="email-input"
                      value={email}
                      name="email"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("email-input")}
                      onBlur={() => handleBlur("email-input")}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="phone-number-input"
                      className={`text ${
                        focus["phone-number-input"] ? "focus" : ""
                      }`}
                    >
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="phone-number-input"
                      value={phoneNumber}
                      name="phoneNumber"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("phone-number-input")}
                      onBlur={() => handleBlur("phone-number-input")}
                    />
                  </div>
                </div>
                <div className="apartment-details">
                  <div className="title">Lavington apartments</div>
                  <div className="house-details">House Number: 10a</div>
                </div>
                <div className="profile-buttons-container">
                  <button className="confirm-button">Confirm changes</button>
                  <button
                    className="confirm-button"
                    onClick={() => {
                      setSelectedOption("");
                    }}
                  >
                    Cancel and Exit
                  </button>
                </div>
              </div>
            </div>
          )}

          {selectedOption === "Password" && (
            <>
              <div className="password-change-container">
                <div className="title-of-page">
                  <div className="">Change Password</div>
                  <div className="sub-text">
                    Enter your old password and chage
                  </div>
                </div>
                <div className="inputs-container">
                  <div className="individual-half">
                    <label
                      htmlFor="change-password-input"
                      className={`text ${
                        focus["change-password-input"] ? "focus" : ""
                      }`}
                    >
                      Old Password
                    </label>
                    <input
                      type="password"
                      id="change-password-input"
                      value="*******"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("change-password-input")}
                      onBlur={() => handleBlur("change-password-input")}
                    />
                  </div>
                  <div className={"individual-half margin-top"}>
                    <label
                      htmlFor="new-password-input"
                      className={`text ${
                        focus["new-password-input"] ? "focus" : ""
                      }`}
                    >
                      New password
                    </label>
                    <input
                      type="password"
                      id="new-password-input"
                      value="*******"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("new-password-input")}
                      onBlur={() => handleBlur("new-password-input")}
                    />
                  </div>
                  <div className={"individual-half margin-top"}>
                    <label
                      htmlFor="confirm-password-input"
                      className={`text ${
                        focus["confirm-password-input"] ? "focus" : ""
                      }`}
                    >
                      Confirm new password
                    </label>
                    <input
                      type="password"
                      id="confirm-password-input"
                      value="*******"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("confirm-password-input")}
                      onBlur={() => handleBlur("confirm-password-input")}
                    />
                  </div>
                </div>
                <div className="profile-buttons-container">
                  <button className="confirm-button">Confirm changes</button>
                  <button
                    className="confirm-button"
                    onClick={() => {
                      setSelectedOption("");
                    }}
                  >
                    Cancel and Exit
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

function getFirstAndLastName(userName) {
  // Split the user name by space to separate the first and last names
  const nameParts = userName.split(" ");

  // Check if the split array has at least two elements (first name and last name)
  if (nameParts.length >= 2) {
    const firstName = nameParts[0]; // First element is the first name
    const lastName = nameParts[1]; // Second element is the last name
    return { firstName, lastName };
  } else {
    // If the input doesn't have a last name, return null for last name
    return { firstName: nameParts[0], lastName: null };
  }
}

export default MidSectionProfile;
